import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

function Footer({theme}) {
  let footerStyle = theme === 'light' ? 'text-center pt-8 pb-6 bg-gray-50' : 'text-center text-white bg-gray-800 pt-8 pb-6 bg-gray-50'
  return (
    <footer className={footerStyle}>
      <div className="text-sm font-semibold py-1">
        Built with <FontAwesomeIcon icon={faHeart} className="text-red-600 mx-1" /> by {' '}
        <a
          href="https://twitter.com/deepwhitman"
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 font-bold"
        >
          Bilal Tahir
        </a>
      </div>
    </footer>
  );
}

export default Footer;